__turbopack_context__.v({
  "button-group": "nsPluG_button-group",
  "center-wrapper": "nsPluG_center-wrapper",
  "content": "nsPluG_content",
});
